module.exports = __webpack_public_path__ + "img/hzb.19341c7a.jpg";